export default "__VITE_ASSET__CSH_itly__"